<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Report an issue</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        @click="handleSend"
      />
    </template>

    <Sheet.Body class="pt-2">
      <ReportFeedbackBody v-model="message" :subject="subject" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon } from '@dacr/icons'
import ReportFeedbackBody from './ReportFeedbackBody.vue'

withDefaults(defineProps<{ subject?: string }>(), { subject: 'report' })

const { close, triggerEvent } = useSheet()

const message = ref('')

const handleSend = () => {
  triggerEvent('success', message.value)
  close()
}
</script>
